import { integerFormatter, dateFormatter } from "../../gridFormatters";

export const backupTrends = [
    {
		"field": "collection_date",
		"headerName": "Collection Date",
		"filter": "agDateColumnFilter",
		"cellRenderer": dateFormatter
	},
	{
		"field": "free",
		"headerName": "Free",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum",
      	"type": "numericColumn",
	},
	{
		"field": "used",
		"headerName": "Pool Used",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"type": "numericColumn",
		"aggFunc": "sum"
	},
	{
		"field": "usable",
		"headerName": "Pool Usable",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
      	"type": "numericColumn",
		"aggFunc": "sum"
	}
];